import { render } from "./HeroiconsSolidBookmark.vue?vue&type=template&id=6c736a0c"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBookmark.vue"]])

export default __exports__